import { createReducer, on } from '@ngrx/store';
import * as updateBankActions from '../actions/update-bank.actions';
import { IUpdateBankResponse } from '../models/employee-bank-detail.model';

export const updateBankFeatureKey = 'updateBank';

export interface UpdateBankState {
  loading: boolean;
  response: IUpdateBankResponse | null;
  error: any;
}

export const initialState: UpdateBankState = {
  loading: false,
  response: null,
  error: null
};

export const reducer = createReducer(
  initialState,
  on(updateBankActions.updateBank, state => ({ ...state, loading: true, error: null })),
  on(updateBankActions.updateBankSuccess, (state, { response }) => ({ ...state, loading: false, response })),
  on(updateBankActions.updateBankFailure, (state, { error }) => ({ ...state, loading: false, error }))
);